module.exports = __webpack_public_path__ + "img/price.54c8d735.png";